import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LicenseSw, LicenseSwType } from '../license-mgt.model';
import { LicenseSwActions, LicenseSwActionTypes } from '../actions/license-sw.actions';

export interface State extends EntityState<LicenseSw> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<LicenseSw> = createEntityAdapter<LicenseSw>({
  selectId: info => info.ACCOUNT
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export interface LicenseSwTypeState {
  isLoading: boolean;
  isLoaded: boolean;
  entities: LicenseSwType[];
}

const initialDetailsState: LicenseSwTypeState = {
  isLoading: false,
  isLoaded: false,
  entities: []
};

export function reducer(
  state = initialState,
  action: LicenseSwActions
): State {
  switch (action.type) {
    case LicenseSwActionTypes.GetLicenseSw: {
      return {...state, Loaded: false, Loading: true};
    }

    case LicenseSwActionTypes.GetLicenseSwList: {
      return {...state, Loaded: false, Loading: true};
    }

    case LicenseSwActionTypes.GetAddLicenseSw: {
      return {...state, Loaded: false, Loading: true};
    }

    case LicenseSwActionTypes.GetUpdateLicenseSw: {
      return {...state, Loaded: false, Loading: true};
    }

    case LicenseSwActionTypes.GetDeleteLicenseSw: {
      return {...state, Loaded: false, Loading: true};
    }

    case LicenseSwActionTypes.AddLicenseSw: {
      return adapter.addOne(action.payload.licenseSw, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.UpsertLicenseSw: {
      return adapter.upsertOne(action.payload.licenseSw, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.UpsertLicenseSws: {
      return adapter.upsertMany(action.payload.licenseSws, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.UpdateLicenseSw: {
      return adapter.updateOne(action.payload.licenseSw, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.DeleteLicenseSw: {
      return adapter.removeOne(action.payload.id, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.LoadLicenseSw: {
      return adapter.addOne(action.payload.licenseSws, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.LoadLicenseSwList: {
      return adapter.upsertMany(action.payload.licenseSws, {...state, Loaded: true, Loading: false});
    }

    case LicenseSwActionTypes.ClearLicenseSws: {
      return adapter.removeAll(state);
    }

    case LicenseSwActionTypes.GetLicenseSwFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case LicenseSwActionTypes.GetLicenseSwListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case LicenseSwActionTypes.GetAddLicenseSwFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case LicenseSwActionTypes.GetUpdateLicenseSwFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case LicenseSwActionTypes.GetDeleteLicenseSwFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case LicenseSwActionTypes.ConfirmLicenseSw: {
      return adapter.updateOne({id: action.payload.licenseKey, changes: { ... state, IsConfirm: true}},
         {...state, Loaded: true, Loading: false});
    }

    default: {
      return state;
    }
  }
}

export function TypeReducer(state: LicenseSwTypeState = initialDetailsState, action: LicenseSwActions): LicenseSwTypeState {

  switch (action.type) {
    case LicenseSwActionTypes.GetLicenseSwType:
      return {...state, isLoading: true, isLoaded: false, entities: state.entities};
    case LicenseSwActionTypes.LoadLicenseSwType:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload.licenseSwTypes };
    case LicenseSwActionTypes.GetLicenseSwTypeFail:
      return {...state, isLoading: false, isLoaded: true };
    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

export const getAzureBlobStorageSASTokenState = (state: LicenseSwTypeState) => state;
